<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="等级名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入等级名称" />
      </a-form-model-item>
      <a-form-model-item label="icon" prop="icon" >
        <file-upload type="image" :defaultList="form.iconArr" :count="1"
                     @input="getImg($event, 'icon')"></file-upload>
        <span style="color: red">建议上传图片尺寸：249*322</span>
      </a-form-model-item>
      <a-form-model-item label="拟物图" prop="image" >
        <file-upload type="image" :defaultList="form.imageArr" :count="1"
                     @input="getImg($event, 'image')"></file-upload>
        <span style="color: red">建议上传图片尺寸：375*667</span>
      </a-form-model-item>
      <a-form-model-item label="种树数量" prop="treeNum" >
        <a-input-number style="width: 300px" :min="0" v-model="form.treeNum" placeholder="请输入种树数量" />
      </a-form-model-item>
      <a-form-model-item label="树占比" prop="treeRadio" >
        <a-input-number style="width: 300px" :min="0" :max="100" v-model="form.treeRadio" placeholder="请输入树占比" />%
      </a-form-model-item>
      <a-form-model-item label="浇水值" prop="waterNum" >
        <a-input-number style="width: 300px" :min="0" v-model="form.waterNum" placeholder="请输入浇水值" />
      </a-form-model-item>
      <a-form-model-item label="浇水值占比" prop="waterRadio" >
        <a-input-number style="width: 300px" :min="0" :max="100" v-model="form.waterRadio" placeholder="请输入浇水值占比" />%
      </a-form-model-item>
      <a-form-model-item label="成长值" prop="growthValue" >
        <a-input-number style="width: 300px" :min="0"  v-model="form.growthValue" placeholder="请输入成长值" />
      </a-form-model-item>
      <a-form-model-item label="权益1" prop="equityOne" >
        <a-input :maxLength="200" v-model="form.equityOne" placeholder="请输入权益内容" type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="权益2" prop="equityTow" >
        <a-input :maxLength="200" v-model="form.equityTow" placeholder="请输入权益内容"  type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="等级说明" prop="content" >
        <editor  v-model="form.content" placeholder="请输入等级说明" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getLevel, addLevel, updateLevel } from '@/api/account/level'
import Editor from "@/components/Editor";
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        name: null,
        image: null,
        imageArr:[],
        imageCount:1,
        icon: null,
        iconArr:[],
        iconCount:1,
        treeNum: null,
        treeRadio: null,
        waterNum: null,
        growthValue:null,
        waterRadio: null,
        equityOne: null,
        equityTow:null,
        content:null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '等级名称不能为空', trigger: 'blur' }
        ],
        // image: [
        //   { required: true, message: '等级图片不能为空', trigger: 'blur' }
        // ],
        treeNum: [
          { required: true, message: '种树数量不能为空', trigger: 'blur' }
        ],
        treeRatio: [
          { required: true, message: '树占比不能为空', trigger: 'blur' }
        ],
        waterNum: [
          { required: true, message: '浇水值不能为空', trigger: 'blur' }
        ],
        waterRatio: [
          { required: true, message: '浇水值占比不能为空', trigger: 'blur' }
        ],
        equityOne: [
          { required: true, message: '权益1不能为空', trigger: 'blur' }
        ],
        equityTow: [
          { required: true, message: '权益2不能为空', trigger: 'blur' }
        ],
        growthValue: [
          { required: true, message: '成长值不能为空', trigger: 'blur' }
        ],
        content:[{
          require: true, message: '等级说明不能为空', trigger: 'blur'
        }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },

    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        image: null,
        imageArr:[],
        imageCount:1,
        icon: null,
        iconArr:[],
        iconCount:1,
        growthValue:null,
        treeNum: null,
        treeRadio: null,
        waterNum: null,
        waterRadio: null,
        equityOne: null,
        equityTow:null,
        content:null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLevel({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
        let that = this
        if(this.form.image){
          this.form.imageArr = []
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
        if(this.form.icon){
          this.form.iconArr = []
          this.form.iconArr.push({
            uid: guid(8, 10),
            name: that.form.icon,
            status: 'done',
            halfUrl: that.form.icon,
            url: that.form.icon,
            path: that.form.icon
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let radio = this.form.treeRadio+this.form.waterRatio
          if(radio > 100){
            this.$message.error("树占比+水滴占比不能超过100%")
            return
          }
          if(radio < 100){
            this.$message.error("树占比+水滴占比必须等于100%")
            return
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updateLevel(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addLevel(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
